// custom typefaces
import "typeface-montserrat";
import "typeface-merriweather";
import "typeface-nunito";
import "typeface-alegreya";

export const onPreRouteUpdate = () => {
  document
    .querySelectorAll(".transition-fade")
    .forEach(el => el.classList.add("is-animating"));
};

export const onRouteUpdate = () => {
  setTimeout(() => {
    document
      .querySelectorAll(".transition-fade")
      .forEach(el => el.classList.remove("is-animating"));
  }, 0);
};
